<template>
  <div id="container">
    <div>
      <div class="mapboxgl-ctrl-bottom-right">
        <a href="https://www.gc.cuny.edu/CUR" target="_blank"
          ><img src="cuny-gc-logo.png"
        /></a>
      </div>
      <div id="map" class="map" ref="map"></div>
    </div>
    <MapLegend />
  </div>
</template>
<script>
import mapboxgl from "mapbox-gl";
import Requests from "../../data/RequestManager";
import fetch from "node-fetch";
import { Config, Enums, Sources } from "../../data/Config/Config";
import LayerManager from "../../data/LayerManager";
import MapLegend from "../../components/DataDisplay/MapLegend.vue";
import MapEvents from "./MapEvents";
import MapSelection from "./MapSelection";
import MapMethods from "./MapMethods";
import { EventBus } from "../../data/EventBus";
import MapboxInspect from "mapbox-gl-inspect";

export default {
  name: "Map",
  components: {
    MapLegend,
  },
  data: function () {
    return {
      map: null,
      cursorStyle: "crosshair",
      selectedDistrictNew: "-1",
      tableSuffix: "demographics",
      marker: null,
    };
  },
  watch: {
    marker: function (val) {
      if (val) {
        const latLng = `${val.getLngLat().lat},${val.getLngLat().lng}`;
        this.$store.commit("setMarkerLoc", latLng);
      }
    },
    mapColumn: function (val, oldVal) {
      if (oldVal) {
        let self = this;
        Config.layersConfig.choroplethLayerArray.forEach((layer) => {
          if (layer.type === "fill") {
            //Needed so you don't get the outline and try to setChoroplethStyle to it
            self.mapMethods.setChoroplethStyle(layer);
          }
        });
      }
    },
    opacitySlideValue: function (val) {
      this.layerManager.SetChoroplethOpacity(val);
    },
    selectedPoint: function (val) {
      if (Object.keys(val).length === 0) return;

      const addressSelected =
        this.$store.getters.getSelectedAddress.place_id !== null &&
        typeof this.$store.getters.getSelectedAddress.place_id !== "undefined";

      //this.selectPoint(val, addressSelected);
    },
    // stateFIPS: function(val){
    //     if(this.map && val){}
    // },
    districtType: function (val, oldVal) {

      //console.log(val)
      this.$store.commit("setSelectedData", {});
      this.mapSelection.selectFromDistrictTypeSwitch(this.selectedPoint, val);
      // if (oldVal) {
      //
      this.layerManager.UpdateLabelVisibility();
      //   if (this.selectedPoint && this.marker) {
      //     this.selectPoint(this.selectedPoint, false);
      //   }

      this.layerManager.UpdateChoroplethLayerVisibility(val);
      try {
        this.layerManager.ClearAllHighlights();
      } catch (e) {
        console.warn("style isn't done loading but it should be ok");
      }

      //   this.waitAndSetNewDistrict();
      // }
    },
    // districtFIPS: function (val) {},
    selectedDistrictNew: function (val) {
      this.$store.commit("setDistrictFIPS", val);
    },
    //districtNumber: function(val){}
  },
  mounted: function () {
    mapboxgl.accessToken = Config.api.keys.CUNYMapBoxKey;

    this.demoArrayManager = Config.demoArrayManager;
    this.map = this.map || new mapboxgl.Map(Config.map.setup);

    this.layerManager = new LayerManager(this);
    this.$store.commit("setMap", this.map);

    if (!this.$store.getters.isMobile) {
      this.map.addControl(new mapboxgl.NavigationControl());
    }

    this.mapSelection = new MapSelection(this);

    const mapEvents = new MapEvents(this);
    mapEvents.attachEvents();

    this.mapMethods = new MapMethods(this);
  },
  methods: {
    async init() {
      // console.log(this.map.getStyle().layers.map((x) => x.id));

      /*this.map.addControl(
        new MapboxInspect({
          showInspectMap: true,
          showMapPopup: true,
          showMapPopupOnHover: true,
          showInspectMapPopupOnHover: false,
        })
      );*/
      Sources.sourceArray.forEach((source) =>
        //console.log(source)
        this.map.addSource(source.name, source.data)
      );

      //TODO: Move to layermanager
      let self = this;
      Config.layersConfig.choroplethLayerArray.forEach((layer) => {
        if (layer.id.includes(self.districtType)) {
          layer.layout = layer.layout = {};
          layer.layout.visibility = "visible";
        } else {
          if (layer.layout) {
            layer.layout.visibility = "none";
          }
        }
      });

      this.layerManager.addCustomLayers();

      this.layerManager.UpdateLabelVisibility();
    },
    async selectPoint(e, autoZoom = true) {
      //Can be removed?

      //Select a location from a point or fips, get the fips if it's from a point
      this.$store.commit("setLoading", true);
      this.selectedPoint = e;
      if (this.marker) this.marker.remove();
      this.marker = null;
      let district = [];
      //Try to get the geoid from queryRenderedFeatures
      if (e.point) {
        this.mapSelection.selectFromClick(e);
      }
      this.$store.commit("setLoading", false);
      //this.mapSelection.select(e, autoZoom);
    },
    //TODO: Move to layer manager
    setHighlight(e) {
      if (
        e.isSourceLoaded &&
        e.sourceId === `${this.districtType}-choro-source` &&
        this.map.getLayer(`${this.districtType}-highlight-outline`)
      ) {
        this.map.setFilter(`${this.districtType}-highlight-outline`, [
          "==",
          ["get", "geoid"],
          this.selectedDistrictNew.toString(),
        ]);

        this.map.triggerRepaint();
        this.map.off("sourcedata", this.setHighlight);
      }
    },
    waitAndSetNewDistrict() {
      if (
        this.map.getSource(`${this.districtType}-choro-source`) &&
        this.map.isSourceLoaded(`${this.districtType}-choro-source`) &&
        typeof this.map.getLayer(`${this.districtType}-highlight-outline`) !==
          "undefined"
      ) {
        this.map.setFilter(`${this.districtType}-highlight-outline`, [
          "==",
          ["get", "geoid"],
          this.selectedDistrictNew.toString(),
        ]);

        this.map.triggerRepaint();
      } else {
        this.map.on("sourcedata", this.setHighlight);
      }
    },
    mapMouseOver() {
      // let dataItems = [];
      // let features = this.map.queryRenderedFeatures(e.point);
      // this.$store.commit("setHoverDisplayData", dataItems);
    },
    async districtDataRequest(
      _selectedDistrictFIPS,
      _districtType,
      _tableSuffix
      //_e
    ) {
      const state = _selectedDistrictFIPS.substring(0, 2); //this.$store.getters.getStateFips;

      const ProPubUrl = Requests.getProPublicaData(
        state,
        this.districtNumFromFips(_selectedDistrictFIPS, true)
      );
      const pp_response = await fetch(ProPubUrl, {
        headers: Requests.getProPublicaHeaders(),
      });
      const pp_json = await pp_response.json();
      if (pp_json.results && typeof pp_json.results !== "undefined") {
        if (pp_json.results.length > 0) {
          pp_json.results[0].dataSource = Enums.DATA_SOURCE.PROPUB;
          this.$store.commit("setSelectedData", pp_json.results[0]);
        }else{
          this.$store.commit("setSelectedData", {});
        }
      }

      const pg_data = this.demoArrayManager.GetDistrictData(
        _selectedDistrictFIPS,
        _districtType
      );
      pg_data.dataSource = Enums.DATA_SOURCE.POSTGRES;

      if (_districtType) this.$store.commit("setSelectedData", pg_data);
    },
    districtNumFromFips: function (_districtFIPS) {

      return +_districtFIPS
        .toString()
        .substring(2, _districtFIPS.length)
        .toString();

    },
    async zoomToSelected() {

      const newbboxURL = Requests.getDistrictBoundingBox(
        this.districtType,
        this.tableSuffix,
        this.selectedDistrictNew
      );

      const new_bbox_response = await fetch(newbboxURL);
      let newBBox = await new_bbox_response.json();

      if (!newBBox[0].bbox) return;
      let newBBoxArr = newBBox[0].bbox
        .replace("BOX(", "")
        .replace(")", "")
        .split(",");

      var bounds = new mapboxgl.LngLatBounds();
      // bounds.extend(oldBBoxArr[0].split(" "));
      // bounds.extend(oldBBoxArr[1].split(" "));
      bounds.extend(newBBoxArr[0].split(" "));
      bounds.extend(newBBoxArr[1].split(" "));

      //console.log(bounds)

      const _padding = {
        top: 75,
        bottom: 20,
        right: 10,
        left: 300,
      };

      const _mobilePadding = {
        top: 200,
        bottom: 0,
        right: 20,
        left: 20,
      };

      this.map.fitBounds(bounds, {
        padding: this.$store.getters.isMobile ? _mobilePadding : _padding,
      });
    },
  },
  computed: {
    mapColumn: {
      get: function () {
        return this.$store.getters.getMapColumn;
      },
      set: function (newValue) {
        this.$store.commit("setMapColumn", newValue);
      },
    },
    opacitySlideValue: {
      get: function () {
        return this.$store.getters.getOpacitySlideValue;
      },
      set: function (newValue) {
        this.$store.commit("setOpacitySlideValue", newValue);
      },
    },
    selectedPoint: {
      get: function () {
        return this.$store.getters.getSelectedPoint;
      },
      set: function (newValue) {
        this.$store.commit("setSelectedPoint", newValue);
      },
    },
    districtType: {
      get: function () {
        return this.$store.getters.getDistrictType;
      },
      set: function (newValue) {
        this.$store.commit("setDistrictType", newValue);
      },
    },
    stateFIPS: {
      get: function () {
        return this.$store.getters.getStateFips;
      },
      set: function (val) {
        this.$store.commit("setStateFips", val);
      },
    },
    // districtNumber: {
    //   get: function () {
    //     return this.$store.getters.getDistrictNumber;
    //   },
    //   set: function (val) {
    //     this.$store.commit("setDistrictFIPS", val);
    //   },
    // },
    selectedAddress: {
      get: function () {
        return this.$store.getters.getSelectedAddress;
      },
    },
    selectedData: {
      get: function () {
        return this.$store.getters.getSelectedData;
      },
    },
    districtFIPS: {
      get: function () {
        return this.$store.getters.getDistrictFIPS;
      },
    },
  },
};
</script>
<style scoped>
body {
  overflow: hidden;
}

body * {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.map,
.mb-map {
  position: absolute;
  top: 64px;
  bottom: 0;
  width: 100%;
  cursor: crosshair;
}
</style>

<style>
.mapboxgl-control-container .mapboxgl-ctrl-bottom-right {
  margin-right: 40px;
}

.mapboxgl-ctrl.mapboxgl-ctrl-attrib {
  margin-right: 12px;
}

.mapboxgl-ctrl-bottom-right {
  pointer-events: auto;
}

.mapboxgl-ctrl-bottom-right img {
  margin-right: 10px;
}
</style>